import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ipm-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
  @Input() buttonName: string= "";
  @Input() buttonAlignment: string= "left";
  @Input() borderGradient: boolean = false;
  @Input() isShowBg: boolean = false;
  @Output()  onClickEvent: EventEmitter<any> = new EventEmitter(); 
  constructor() { }

  ngOnInit(): void {
  }

  triggerClickEvent() {
    this.onClickEvent.emit(true);
  }

}
